export default function AboutHero() {
  return (
    <section id="about_hero">
      <div className="container">
        <div className="row-essy">
          <div className="col-essy-lg-6 col-essy-md-6">
            <div className="about-us-wrapper">
              <h1>About Us</h1>
              <p>
                Essy exists because finding and hiring sales engineers shouldn’t
                be this hard. We’re a team that’s spent over a decade cracking
                the code of sales engineering recruitment, with hundreds of
                placements for SaaS and tech companies worldwide to show for it.
                Now, we’re making those connections happen on one focused
                platform.
              </p>
            </div>
          </div>
          <div className="col-essy-lg-6 col-essy-md-6"></div>
        </div>
      </div>
    </section>
  );
}
